import { useMemo } from 'react';
import { i18n } from '../../../shared/localization';

const { edrAction } = i18n.pages.detections.entityEDR;

/**
 * Custom hook to determine if a pending EDR state tooltip should be displayed
 * @param entity_edr_status - The current EDR status of the entity
 * @returns The tooltip text if status is pending, undefined otherwise
 */
export const usePendingEdrStateTooltip = (
  entity_edr_status: string | undefined,
): string | undefined => {
  return useMemo(() => {
    if (
      entity_edr_status === 'isolation_pending' ||
      entity_edr_status === 'lift_isolation_pending'
    ) {
      return edrAction.pendingStateTooltip;
    }
    return undefined;
  }, [entity_edr_status]);
};
